import React, { useEffect } from 'react';
import { IoMdRefresh } from 'react-icons/io';
import { RiAddBoxFill } from 'react-icons/ri';
import {
  advanceAmountMethods,
  filtermetals,
  getAllPaymentMethod,
  getAllPaymentMethodForNoInovice,
  metals,
} from 'utils/helpers';
import styles from '../Pages/PagesStyles/AdminPurchaseEntryNew.module.css';
import { useForm } from 'react-hook-form';
import { FaPlus } from 'react-icons/fa';
import { GoPlus } from 'react-icons/go';
import { Add, PlusOne, Refresh } from '@mui/icons-material';



const PaymentModeFormRepair = ({
  addPaymentMode,
  invoiceNumber,
  AdvanceAmount,
  editStatus,
  skus,
  componentType = '',
  gstCheckbox,
}) => {
  const {
    register,
    handleSubmit,
    control,
    watch,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      status: componentType == 'Invoice' ? 'received' : 'paid',
      mode: '',
      amount: 0,
      description: '',
      AdvanceAmountStatus: 'advanceReceived',
      AdvanceAmount: '',
      AmountAvailable: '',
      DeductAmount: '',
      MetalType: '',
      MetalFinePaid: '',
      RatePerGram: '',
      TotalAmount: '',
      MetalFinePercent: '',
    },
  });

  const amount = watch('amount');
  const mode = watch('mode');
  const status = watch('status');
  const AdvanceAmountStatus = watch('AdvanceAmountStatus');
  const MetalFinePercent = watch('MetalFinePercent');
  const MetalTotalWeight = watch('MetalTotalWeight');
  const MetalCashRatePerGram = watch('MetalCashRatePerGram');
  const MetalCashTotalAmount = watch('MetalCashTotalAmount');
  const MetalFinePaid = watch('MetalFinePaid');

  useEffect(() => {
    setValue('AmountAvailable', +AdvanceAmount);
  }, [AdvanceAmount]);

  useEffect(() => {
    if (mode == 'Metal') {
      setValue(
        'MetalFinePaid',
        (+MetalTotalWeight * (+MetalFinePercent / 100))?.toFixed(3)
      );
    }
  }, [MetalTotalWeight, MetalFinePercent]);

  useEffect(() => {
    if (mode == 'Metal') {
      setValue(
        'MetalFinePaid',
        (+MetalTotalWeight * (+MetalFinePercent / 100))?.toFixed(3)
      );
    }
  }, [MetalTotalWeight, MetalFinePercent]);

  useEffect(() => {
    if (mode == 'Metal to Cash') {
      setValue(
        'MetalCashTotalAmount',
        (+MetalFinePaid * +MetalCashRatePerGram)?.toFixed(3)
      );
    }
  }, [MetalFinePaid, MetalCashRatePerGram]);

  useEffect(() => {
    if (mode == 'Cash to Metal') {
      setValue(
        'MetalFinePaid',
        (+MetalCashTotalAmount / +MetalCashRatePerGram)?.toFixed(3)
      );
    }
  }, [MetalCashTotalAmount, MetalCashRatePerGram]);

  const handleReset = () => {
    setValue('amount', 0);
    setValue('description', '');
    setValue('mode', '');
    setValue('AdvanceAmountStatus', '');
    setValue('AdvanceAmount', '');
    // setValue("AmountAvailable", "");
    setValue('DeductAmount', '');
    setValue('MetalType', '');
    setValue('FinePaid', '');
    setValue('RatePerGram', '');
    setValue('TotalAmount', '');
    setValue('status', '');
  };

  useEffect(() => {
    if (AdvanceAmountStatus == 'advanceReceived') {
      setValue('AmountAvailable', '');
      setValue('DeductAmount', '');
    }
    if (AdvanceAmountStatus == 'deductAdvance') {
      setValue('AdvanceAmount', '');
    }
  }, [AdvanceAmountStatus]);

  useEffect(() => {
    setValue('amount', 0);
    setValue('description', '');
    setValue('AdvanceAmountStatus', '');
    setValue('AdvanceAmount', '');
    // setValue("AmountAvailable", "");
    setValue('DeductAmount', '');
    setValue('MetalType', '');
    setValue('RatePerGram', '');
    setValue('TotalAmount', '');
    setValue('MetalTotalWeight', '');
    setValue('MetalFinePercent', '');
    setValue('MetalFinePaid', '');
    setValue('MetalCashRatePerGram', '');
    setValue('MetalCashTotalAmount', '');
  }, [mode]);

  const paymentMode = () => {
    handleSubmit(onSubmit)();
  };

  const onSubmit = (data) => {
    addPaymentMode(data);
    handleReset();
    setValue('status', componentType == 'Invoice' ? 'received' : 'paid');
  };

  return (
    <>
      <div style={{ width: '100%' }}>
        <div className={styles.radioBar}>
          <label className={styles.radioLabel}>
            <input
              type="radio"
              value="paid"
              {...register('status', {
                required: 'Please select an option',
              })}
            />
            Paid
          </label>
          <label className={styles.radioLabel}>
            <input
              type="radio"
              value="received"
              {...register('status', {
                required: 'Please select an option',
              })}
            />
            Received
          </label>
          <label className={styles.radioLabel}>
            <input
              type="radio"
              value="advance"
              {...register('status', {
                required: 'Please select an option',
              })}
            />
            Advance
          </label>
        </div>
        {errors?.status && (
          <p
            style={{
              padding: '0px',
              margin: '0px',
              display: 'flex',
              paddingLeft: '8px',
              color: 'red',
              fontSize: '12px',
              justifyContent: 'start',
              alignItems: 'start',
            }}
          >
            {errors?.status?.message}
          </p>
        )}
      </div>

      <div className={styles.leftInputs}>
        <div
        className={styles.paymentBox}
          // style={{
          //   display: 'flex',
          //   flexDirection: 'column',
          //   alignItems: 'start',
          //   marginLeft: '10px',
          // }}
        >
          <label>Payment Mode </label>
          <select
          className={styles.PaymentSelect}
            {...register('mode', {
              required: 'Please select a payment mode',
            })}
          >
            <option value="">-- Select --</option>
            {(status == 'advance'
              ? advanceAmountMethods()
              : gstCheckbox
              ? getAllPaymentMethod()
              : getAllPaymentMethodForNoInovice()
            )?.map((item) => (
              <option value={item?.value}>{item?.title}</option>
            ))}
          </select>
        </div>

        <div
         className={styles.paymentBox}
          // style={{
          //   display: 'flex',
          //   flexDirection: 'column',
          //   alignItems: 'start',
          // }}
        >
          {mode == 'Metal' ||
          mode == 'Metal to Cash' ||
          mode == 'Cash to Metal' ? (
            ''
          ) : (
            <>
              <label>Amount</label>
              <input
                type="number"
                className={styles.PaymentSelect}
                {...register('amount', {
                  required: 'Amount is required',
                  min: {
                    value: 1, // Minimum value allowed
                    message: 'Amount must be greater than 0',
                  },
                  // validate:
                  //  {
                  //   maxForCash: (value) => {
                  //     if (
                  //       watch('mode') == 'Cash' &&
                  //       !gstCheckbox &&
                  //       value > 10000
                  //     ) {
                  //       return 'Amount cannot exceed 10,000 for Cash mode';
                  //     }
                  //     if (
                  //       watch('mode') == 'Cash' &&
                  //       gstCheckbox &&
                  //       value > 200000
                  //     ) {
                  //       return 'Amount cannot exceed 2,00,000 for Cash mode';
                  //     }
                  //     return true; 
                  //   },
                  // },
                })}
                style={{border: '1px solid #ddd'}}
              />

              {/* {errors.amount && (
            <p className={styles.error}>{errors.amount.message}</p>
          )} */}
            </>
          )}
        </div>

        <div
        className={styles.paymentBox}
          // style={{
          //   display: 'flex',
          //   flexDirection: 'column',
          //   alignItems: 'start',
          // }}
        >
          {mode == 'Metal' ||
          mode == 'Metal to Cash' ||
          mode == 'Cash to Metal' ? (
            ''
          ) : (
            <>
              <label>Description</label>
              <input
                className={styles.PaymentSelect}
                type="text"
                {...register(
                  'description'
                  //   {
                  //   required: "Description is required",
                  // }
                )}
                style={{ border: '1px solid #ddd' }}
              />
              {/* {errors.description && (
              <p className={styles.error}>{errors.description.message}</p>
               )} */}
            </>
          )}
        </div>
        <div
          style={{
            display: 'flex',
          
            alignItems: 'start',
            marginLeft: '10px',
            marginTop: '12px',
            gap: '15px'
          }}
        >
        <Add
          onClick={paymentMode}
          type="button"
          style={{
            cursor: 'pointer',
            fontSize: '30px',
            background: '#0077d4',
            color: 'white',
            border: '1px solid #0077d4',
            borderRadius: '20%',
          }}
        />
        <Refresh
          onClick={handleReset}
          type="button"
          style={{
            cursor: 'pointer',
            fontSize: '30px',
            background: 'white',
            color: '#0077d4',
            border: '1px solid #0077d4',
            borderRadius: '20%',
          }}
        />
        </div>
      </div>

      {/* <div className={styles.leftInputs}>
        <div>
          {errors.mode && <p className={styles.error}>{errors.mode.message}</p>}
        </div>
        <div>
          {errors.amount && (
            <p className={styles.error}>{errors.amount.message}</p>
          )}
        </div>
        <div>
          {errors.description && (
            <p className={styles.error}>{errors.description.message}</p>
          )}
        </div>
      </div> */}

      {status == 'advance' ? (
        <>
          {/* <div className={styles.radioBar} style={{ marginTop: "10px" }}>
            <label className={styles.radioLabel} style={{ display: "flex" }}>
              <input
                type="radio"
                value="advanceReceived"
                {...register("AdvanceAmountStatus", {
                  required: "Please select an option",
                })}
              />
              Adv Rcvd
            </label>
            <label className={styles.radioLabel}>
              <input
                type="radio"
                value="deductAdvance"
                {...register("AdvanceAmountStatus", {
                  required: "Please select an option",
                })}
              />
              Deduct Adv
            </label>
          </div> */}

          <div className={styles.leftInputs}>
            {/* {AdvanceAmountStatus == "advanceReceived" ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "start",
                }}
              >
                <label>Amount</label>
                <input
                  type="number"
                  {...register("AdvanceAmount", {
                    required: "Amount is required",
                    validate: (value) =>
                      value > 0 || "Amount must be greater than 0",
                  })}
                />
                {errors.AdvanceAmount && (
                  <p className={styles.error}>{errors.AdvanceAmount.message}</p>
                )}
              </div>
            ) : ( */}
            <>
              <div
              className={styles.paymentBox}
                // style={{
                //   display: 'flex',
                //   flexDirection: 'column',
                //   alignItems: 'start',
                //   marginLeft: '10px'
                // }}
              >
                <label>Amount Available</label>
                <input
                className={styles.PaymentSelect}
                style={{border: '1px solid #ddd'}}
                  type="number"
                  disabled={true}
                  {...register('AmountAvailable')}
                />
              </div>
              <div
              className={styles.paymentBox}
                // style={{
                //   display: 'flex',
                //   flexDirection: 'column',
                //   alignItems: 'start',
                //    marginLeft: '10px'
                // }}
              >
                <label>Deduct Amount</label>
                <input
                 className={styles.PaymentSelect}
                style={{border: '1px solid #ddd'}}
                type="number" {...register('DeductAmount')} />
              </div>
            </>
            {/* )} */}

            {/* <div>
              <button type="button" onClick={paymentMode}>
                <RiAddBoxFill size={24} />
              </button>
              <button type="button" onClick={handleReset}>
                <IoMdRefresh size={24} />
              </button>
            </div> */}
          </div>
        </>
      ) : mode == 'Metal' ? (
        <div className={styles.leftInputs}>
          <div
          className={styles.paymentBox}
            // style={{
            //   display: 'flex',
            //   flexDirection: 'column',
            //   alignItems: 'start',
            // }}
          >
            <label>Metal</label>
            <select
            className={styles.PaymentSelect}
              {...register('MetalType', {
                // required: "Please select a payment mode",
              })}
            >
              <option value="">-- Select --</option>
              {(mode == 'Metal' ? filtermetals(skus) : metals())?.map(
                (item) => (
                  <option value={item?.value}>{item?.title}</option>
                )
              )}
            </select>
            {/* {errors.metal && (
            <p className={styles.error}>{errors.metal.message}</p>
          )} */}
          </div>

          <div
           className={styles.paymentBox}
            // style={{
            //   display: 'flex',
            //   flexDirection: 'column',
            //   alignItems: 'start',
            // }}
          >
            <label>Total Weight</label>
            <input
             className={styles.PaymentSelect}
              type="number"
              {...register('MetalTotalWeight', {
                required: 'Fine paid is required',
                // validate: (value) =>
                //   value > 0 || "Amount must be greater than 0",
              })}
            />
            {/* {errors.MetalTotalWeight && (
            <p className={styles.error}>{errors.MetalTotalWeight.message}</p>
          )} */}
          </div>
          <div
           className={styles.paymentBox}
            // style={{
            //   display: 'flex',
            //   flexDirection: 'column',
            //   alignItems: 'start',
            // }}
          >
            <label>Fine %</label>
            <input
             className={styles.PaymentSelect}
              type="number"
              {...register('MetalFinePercent', {
                // required: "Rate is required",
                // validate: (value) =>
                //   value > 0 || "Amount must be greater than 0",
              })}
            />
            {/* {errors.RatePerGram && (
            <p className={styles.error}>{errors.RatePerGram.message}</p>
          )} */}
          </div>
          <div
           className={styles.paymentBox}
            // style={{
            //   display: 'flex',
            //   flexDirection: 'column',
            //   alignItems: 'start',
            // }}
          >
            <label>Fine Paid</label>
            <input
             className={styles.PaymentSelect}
              type="number"
              {...register('MetalFinePaid', {
                // required: "Total amount is required",
                // validate: (value) =>
                //   value > 0 || "Amount must be greater than 0",
              })}
            />
            {/* {errors.TotalAmount && (
            <p className={styles.error}>{errors.TotalAmount.message}</p>
          )} */}
          </div>
        </div>
      ) : mode == 'Metal to Cash' ? (
        <div className={styles.leftInputs}>
          <div
           className={styles.paymentBox}
            // style={{
            //   display: 'flex',
            //   flexDirection: 'column',
            //   alignItems: 'start',
            // }}
          >
            <label>Metal</label>
            <select
              className={styles.PaymentSelect}
              {...register('MetalType', {
                // required: "Please select a payment mode",
              })}
            >
              <option value="">-- Select --</option>
              {metals()?.map((item) => (
                <option value={item?.value}>{item?.title}</option>
              ))}
            </select>
            {/* {errors.metal && (
            <p className={styles.error}>{errors.metal.message}</p>
          )} */}
          </div>

          <div
          className={styles.paymentBox}
            // style={{
            //   display: 'flex',
            //   flexDirection: 'column',
            //   alignItems: 'start',
            // }}
          >
            <label>Fine Paid</label>
            <input
             className={styles.PaymentSelect}
              type="number"
              {...register('MetalFinePaid', {
                // required: "Fine paid is required",
                // validate: (value) =>
                //   value > 0 || "Amount must be greater than 0",
              })}
            />
            {/* {errors.FinePaid && (
            <p className={styles.error}>{errors.FinePaid.message}</p>
          )} */}
          </div>
          <div
           className={styles.paymentBox}
            // style={{
            //   display: 'flex',
            //   flexDirection: 'column',
            //   alignItems: 'start',
            // }}
          >
            <label>Rate/Gm</label>
            <input
               className={styles.PaymentSelect}
              type="number"
              {...register('MetalCashRatePerGram', {
                // required: "Rate is required",
                // validate: (value) =>
                //   value > 0 || "Amount must be greater than 0",
              })}
            />
            {/* {errors.RatePerGram && (
            <p className={styles.error}>{errors.RatePerGram.message}</p>
          )} */}
          </div>
          <div
           className={styles.paymentBox}
            // style={{
            //   display: 'flex',
            //   flexDirection: 'column',
            //   alignItems: 'start',
            // }}
          >
            <label>Total Amount</label>
            <input
             className={styles.PaymentSelect}
              type="number"
              {...register('MetalCashTotalAmount', {
                // required: "Total amount is required",
                // validate: (value) =>
                //   value > 0 || "Amount must be greater than 0",
              })}
            />
            {/* {errors.TotalAmount && (
            <p className={styles.error}>{errors.TotalAmount.message}</p>
          )} */}
          </div>
        </div>
      ) : mode == 'Cash to Metal' ? (
        <div className={styles.leftInputs}>
          <div
          className={styles.paymentBox}
            // style={{
            //   display: 'flex',
            //   flexDirection: 'column',
            //   alignItems: 'start',
            // }}
          >
            <label>Metal</label>
            <select
            className={styles.PaymentSelect}
              {...register('MetalType', {
                // required: "Please select a payment mode",
              })}
            >
              <option value="">-- Select --</option>
              {(mode == 'Cash to Metal' ? filtermetals(skus) : metals())?.map(
                (item) => (
                  <option value={item?.value}>{item?.title}</option>
                )
              )}
            </select>
            {/* {errors.metal && (
              <p className={styles.error}>{errors.metal.message}</p>
            )} */}
          </div>
          <div
            className={styles.paymentBox}
            // style={{
            //   display: 'flex',
            //   flexDirection: 'column',
            //   alignItems: 'start',
            // }}
          >
            <label>Total Amount</label>
            <input
              className={styles.PaymentSelect}
              type="number"
              {...register('MetalCashTotalAmount', {
                // required: "Total amount is required",
                // validate: (value) =>
                //   value > 0 || "Amount must be greater than 0",
              })}
            />
            {/* {errors.TotalAmount && (
              <p className={styles.error}>{errors.TotalAmount.message}</p>
            )} */}
          </div>

          <div
           className={styles.paymentBox}
            // style={{
            //   display: 'flex',
            //   flexDirection: 'column',
            //   alignItems: 'start',
            // }}
          >
            <label>Rate/Gm</label>
            <input
            className={styles.PaymentSelect}
              type="number"
              {...register('MetalCashRatePerGram', {
                // required: "Rate is required",
                // validate: (value) =>
                //   value > 0 || "Amount must be greater than 0",
              })}
            />
            {/* {errors.RatePerGram && (
              <p className={styles.error}>{errors.RatePerGram.message}</p>
            )} */}
          </div>
          <div
           className={styles.paymentBox}
            // style={{
            //   display: 'flex',
            //   flexDirection: 'column',
            //   alignItems: 'start',
            // }}
          >
            <label>Fine Paid</label>
            <input
            className={styles.PaymentSelect}
              type="number"
              {...register('MetalFinePaid', {
                // required: "Fine paid is required",
                // validate: (value) =>
                //   value > 0 || "Amount must be greater than 0",
              })}
            />
            {/* {errors.FinePaid && (
              <p className={styles.error}>{errors.FinePaid.message}</p>
            )} */}
          </div>
        </div>
      ) : (
        ''
      )}

     
    </>
  );
};

export default PaymentModeFormRepair;
